// NPM Imports
import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Loader, Toastr, Tooltip, Button, Input } from "@revvsales/components";

// Action Imports
import SharedDocumentActions from "../../../actions/SharedDocumentActions";
import { getUserByEmailV2 } from "../../../actions/SharedDocumentActions/sharedDocumentServices";

import { DocumentUtils, GlobalUtils } from "../../../utils";

const { readDataFromLocalStorage } = GlobalUtils;

const {
  updateDocumentSharing,
  deleteSharedDocument,
  fetchDocumentSharing,
} = SharedDocumentActions;

const { _emailIsValid } = DocumentUtils;

class DocSharingPopup extends Component {
  state = {
    sharedUsers: [
      {
        user_email: "",
        first_name: "",
        last_name: "",
        id: 0,
        disabled: false,
      },
    ],
    errMsg: "",
    showLoader: false,
    showShareBtnLoader: false,
  };

  componentDidMount() {
    this.setState({ showLoader: true });
    this.props
      .fetchDocumentSharing(this.props.docID)
      .then(() => {
        this.setState({ showLoader: false });
      })
      .catch(error => {
        console.error(
          "DocSharingPopup => fetchDocumentSharing => Error",
          error,
        );
        this.setState({ showLoader: false });
      });
  }

  // Handle dynamic  Fields
  _handleValue = (e, i, name) => {
    const data = [...this.state.sharedUsers];
    if (name === "user_email") {
      data[i].disabled = false;
      data[i][name] = e.target.value;
      data[i].id = 0;
      data[i].first_name = "";
      data[i].last_name = "";

      if (
        e.target.value.length > 0 &&
        _emailIsValid(e.target.value) === false
      ) {
        data[i].notValid = true;
      } else {
        delete data[i].notValid;
      }
    } else {
      data[i][name] = e.target.value;
    }
    this.setState(() => ({ sharedUsers: data, errMsg: "" }));
  };

  // get users from the state for the validation
  getUserStateData = email => {
    const value = [];
    for (let i = 0; i < this.state.sharedUsers.length - 1; i += 1) {
      if (this.state.sharedUsers[i].user_email === email) {
        value.push(email);
      }
    }
    return value;
  };

  // validation the users on three parameters:-
  // 1. does user exists in the state
  // 2. does document has already been shared with the user
  // 3. checking does user already a internal user
  // 4. checking for self sharing
  _selectUserEmailValidation = async (e, i, name) => {
    const data = [...this.state.sharedUsers];
    if (name === "user_email") {
      data[i][name] = e.target.value;
      if (data[i][name] === "") {
        return;
      }
      if (e.target.value.length > 0 && _emailIsValid(e.target.value) === true) {
        const currentLoggedInUser = readDataFromLocalStorage("revvsalesUser");
        const user = await getUserByEmailV2(data[i][name], true);
        const stateUser = this.getUserStateData(data[i][name]);
        if (
          currentLoggedInUser &&
          currentLoggedInUser.user_email === data[i][name]
        ) {
          data[i].disabled = true;
          this.setState({
            errMsg:
              "As the doc owner, you cannot share this document with yourself.",
          });
        } else {
          const sharedUser = this.props.sharedUsers
            ? this.props.sharedUsers.find(
                item => item.User.user_email === data[i][name],
              )
            : null;
          if (stateUser && stateUser.length > 0) {
            this.setState({
              errMsg: "This email is  already added in the list.",
            });
          } else if (sharedUser) {
            data[i].disabled = true;
            this.setState({
              errMsg: "On this email already document has been shared.",
            });
          } else if (user.users && user.users.length > 0) {
            data[i].disabled = true;
            data[i].id = user.users[0].id;
            data[i].first_name = user.users[0].first_name;
            data[i].last_name = user.users[0].last_name;
            this.setState({
              errMsg: "",
            });
          }
        }
      }
    }
    this.setState(() => ({ sharedUsers: data }));
  };

  // Add more users for the sharing
  _onAddMoreUsers = () => {
    const data = [...this.state.sharedUsers];
    data.push({
      user_email: "",
      first_name: "",
      last_name: "",
    });
    this.setState(() => ({ sharedUsers: data }));
  };

  // Remove the add users from state
  _onRemoveSharedUser = index => {
    const data = [...this.state.sharedUsers];
    data.splice(index, 1);
    this.setState(() => ({ sharedUsers: data, errMsg: "" }));
  };

  // to remove users with whom document has already been shared
  _onRemoveAlreadySharedUser = ShareHash => {
    this.props.deleteSharedDocument(ShareHash);
  };

  // After sharing reset the input feilds
  resetItems = () => {
    if (this.state.sharedUsers.length && this.state.sharedUsers.length > 0) {
      this.setState({
        sharedUsers: [],
      });
    }
    this.setState({
      sharedUsers: [{ user_email: "", first_name: "", last_name: "" }],
    });
  };

  _shareDocument = () => {
    this.setState({ showShareBtnLoader: true });
    this.props
      .updateDocumentSharing(this.props.docID, this.state.sharedUsers)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Document has been shared successfully.",
          timeout: 2000,
        });
        this.setState({ showShareBtnLoader: false });
        this.resetItems();
      })
      .catch(error => {
        this.setState({ showShareBtnLoader: false });
        console.error("DocSharingPopup => shareDocument : Error", error);
      });
  };

  // For updating the button once inputs are feild
  updateButtonStatus = data => {
    let status = false;
    if (data.length > 0) {
      data.forEach(items => {
        if (
          items.user_email === "" ||
          items.first_name === "" ||
          items.last_name === ""
        ) {
          status = true;
        }
      });
    } else {
      status = true;
    }
    return status;
  };

  render() {
    const { crm_account: crmAccount } = this.props;
    const errMsgSpace =
      this.state.errMsg !== "" ? (
        <div
          className="error-message-wrapper docsharingpopup-errormg-wrapper"
          data-test="doc-sharing-popup-error-message">
          {this.state.errMsg}
        </div>
      ) : null;
    return (
      <Modal
        open
        onClose={this.props.closePopup}
        closeOnOverlayClick={false}
        center>
        {this.state.showLoader && <Loader className="saving-document" />}
        <div className="opposharepopup">
          <div className="row">
            <div className="col-md-12">
              <div
                className="createdoc-title"
                data-test="doc-sharing-popup-title">
                Sharing options for {this.props.docName}
              </div>
              {errMsgSpace}
              <div className="popup-form">
                <div className="oppo-sharing-info-box">
                  {crmAccount ? (
                    <div className="account-details-container">
                      <span
                        className="account-details-metatitle"
                        data-test="doc-sharing-popup-accountCOLLABORATORS-heading">
                        <i>
                          <FontAwesomeIcon icon={["far", "briefcase"]} />
                        </i>
                        Account
                      </span>
                      <span className="pipeline-acc">{crmAccount.name}</span>
                    </div>
                  ) : null}
                </div>
              </div>
              {/* Share user input form fields */}
              <div
                className="docsharingpopup-sharingform-title"
                data-test="docsharing-popup-sharingform-title">
                You can share this document with internal and external
                stakeholders
              </div>
              <div className="docsharingpopup-sharing-form-wrapper">
                <div>
                  {this.state.sharedUsers.map((data, i) => (
                    <Fragment>
                      <div className="docsharingpopup-sharingform-row form-row">
                        <div className="col-md-5 docsharingpopup-sharingform-col">
                          {/* <Label>
                            EMAIL
                            <span className="required-input">*</span>
                          </Label> */}
                          <Input
                            style={
                              data.notValid
                                ? { borderColor: "red" }
                                : { borderColor: "" }
                            }
                            type="text"
                            value={data.user_email}
                            placeholder="Email here"
                            data-test="docsharing-popup-user-email"
                            onChange={e =>
                              this._handleValue(e, i, "user_email")
                            }
                            onBlur={e =>
                              this._selectUserEmailValidation(
                                e,
                                i,
                                "user_email",
                              )
                            }
                            autoFocus
                          />
                        </div>
                        <div className="col-md-3 docsharingpopup-sharingform-col">
                          {/* <Label>
                            FIRST NAME ({i + 1})
                            <span className="required-input">*</span>
                          </Label> */}
                          <Input
                            type="text"
                            disabled={data.disabled}
                            value={data.first_name}
                            placeholder="First name"
                            data-test="docsharing-user-firstname"
                            onChange={e =>
                              this._handleValue(e, i, "first_name")
                            }
                          />
                        </div>
                        <div className="col-md-3 docsharingpopup-sharingform-col">
                          {/* <Label>
                            LAST NAME ({i + 1})
                            <span className="required-input">*</span>
                          </Label> */}
                          <Input
                            type="text"
                            disabled={data.disabled}
                            value={data.last_name}
                            placeholder="Last name"
                            data-test="docsharing-user-lastname"
                            onChange={e => this._handleValue(e, i, "last_name")}
                          />
                        </div>
                        <div className="col-md-1 docsharingpopup-sharingform-col">
                          <span
                            className="btn-icon"
                            onClick={() => this._onRemoveSharedUser(i, data)}
                            onKeyPress={() => {}}
                            role="button"
                            tabIndex="0">
                            <FontAwesomeIcon icon={["far", "trash-alt"]} />
                          </span>
                        </div>
                      </div>
                    </Fragment>
                  ))}
                </div>
                {/* ------------------- Add more users and share section ------------------- */}
                <div className="docsharingpopup-sharingform-footer">
                  <div className="docsharingpopup-addmoreuser-btn">
                    <Tooltip placement="right" overlay="Add more users">
                      <Button
                        className="revv-btn-secondary"
                        data-test="docsharing-popup-add-btn"
                        onClick={this._onAddMoreUsers}>
                        <i className="plusiconadd">
                          <FontAwesomeIcon
                            icon={["far", "plus"]}
                            className=""
                          />{" "}
                        </i>
                        &nbsp; Add user
                      </Button>
                    </Tooltip>
                  </div>

                  <div className="docsharingpopup-sharebtn-wrapper">
                    <Button
                      isLoading={this.state.showShareBtnLoader}
                      data-test="docsharing-popup-share-btn"
                      disabled={this.updateButtonStatus(this.state.sharedUsers)}
                      className="btn btn-success docsharingpopup-sharebtn"
                      onClick={() => this._shareDocument()}>
                      Share
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="docsharingpopup-sharingform-title">
            Users Who Have Access
          </div>
          <div className="docsharingpopup-sharedusers-wrapper">
            {" "}
            {this.props.sharedUsers
              ? this.props.sharedUsers.map(data => (
                  <Fragment>
                    <div className="docsharingpopup-sharedusers-row">
                      <div className="col-md-4 docsharingpopup-sharedusers-col">
                        <span
                          className="pipeline-acc"
                          data-test="docsharing-user-name">
                          {data.User.first_name} {data.User.last_name}
                        </span>
                      </div>
                      <div className="col-md-6 docsharingpopup-sharedusers-col">
                        <span
                          className="pipeline-opportunity"
                          data-test="docsharing-user-email">
                          {data.User.user_email}
                        </span>
                      </div>
                      {/* delete users */}
                      <div className="col-md-2 docsharingpopup-sharedusers-col ">
                        <span
                          className="btn-icon"
                          data-test="docsharing-popup-user-delete"
                          onClick={() =>
                            this._onRemoveAlreadySharedUser(data.ShareHash)
                          }
                          onKeyPress={() => {}}
                          role="button"
                          tabIndex="0">
                          <FontAwesomeIcon icon={["far", "trash-alt"]} />
                        </span>
                      </div>
                    </div>
                  </Fragment>
                ))
              : null}
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { sharedUsers, users } = state.SharedDocument;
  return {
    sharedUsers,
    users,
  };
};

const mapDispatchToProps = {
  updateDocumentSharing,
  deleteSharedDocument,
  fetchDocumentSharing,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocSharingPopup);



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbarBtns/DocSharingPopup.js